// extracted by mini-css-extract-plugin
module.exports = {"galleryDesktop":"gallery-module--galleryDesktop--3Prjp","galleryMobile":"gallery-module--galleryMobile--3VSOQ"};